module.exports = __webpack_public_path__ + "93a9410ac5ca27be198b1b6ff82f538e.pdf";